import {Component} from '@angular/core';

@Component({
  selector: 'bmc-icons-16',
  templateUrl: './icons-16.html',
  styleUrls: ['./icons.component.scss']
})
export class Icon16Component {

}

@Component({
  selector: 'bmc-icons-32',
  templateUrl: './icons-32.html',
  styleUrls: ['./icons.component.scss']
})
export class Icon32Component {

}

